import * as actionTypes from './actionTypes';

export const setCalendar = (calendar) => ({
  type: actionTypes.SET_CALENDAR,
  calendar
});

export const setSetting = () => {
};
